import {createFileRoute, redirect} from '@tanstack/react-router'

import privateRoute from '@/auth/middleware/privateRoute'

export const Route = createFileRoute('/_account/order/$orderId/')({
  beforeLoad: ({context, location, params}) => {
    privateRoute(context.store, location.href)

    throw redirect({to: '/orders/$orderId', params: {orderId: params.orderId}, replace: true})
  },
})
